export const LOGOUT_EVENT = 'LOGOUT_EVENT'
export const NAVIGATION_EVENT = 'NAVIGATION_EVENT'

export const DIAL_CALL_EVENT = Object.freeze({
  RINGING: 'ringCall',
  ANSWER: 'answerCall',
  ENDED: 'endCall',
  SET_AUDIO_TRACK: 'setAudioTrack',
})

export const MONITOR_EVENT = Object.freeze({
  AVAILABLE_AGENT: 'availableAgent',
  UPDATE_MONITOR_AGENT_DASHBOARD: 'updateMonitorAgentDashboard',
  UPDATE_MONITOR_ALL_AGENT: 'updateMonitorAllAgent',
  UPDATE_MONITOR_AGENT: 'updateMonitorAgent',
  UPDATE_MONITOR_PHONE_TYPE_AGENT: 'updateMonitorPhoneTypeAgent',
  UPDATE_MONITOR_CALL: 'updateMonitorCall',
  UPDATE_MONITOR_CALL_LIST: 'updateMonitorCallList',
  UPDATE_MONITOR_CALL_DETAILS: 'updateMonitorCallDetails',
  UPDATE_MONITOR_CALL_ENDED: 'updateMonitorCallEnded',
})
